import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payroll-filter',
  templateUrl: './payroll-filter.component.html',
  styleUrls: ['./payroll-filter.component.css']
})
export class PayrollFilterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/salaries/payroll-filter/payroll-filter.component.ts